var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v("Тут будет страница \"Мнение психолога\"")])])])
}]

export { render, staticRenderFns }